<template>
    <div>

        <el-form @submit.native.prevent="onSubmitMatricula" :model="dados" ref="dados" label-position="top">
            <c-panel>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="dados['aluno']['codigo_sed'] ? 13 : 18" :md="dados['aluno']['codigo_sed'] ? 13 : 18">
                        <el-form-item label="Aluno" prop="aluno.nome" :rules="[$requiredChange]" key="nome">
                            <el-input readonly v-model="dados['aluno']['nome']" maxlength="191" class="readonly"></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- Integração SED: o aluno já foi cadastrado na SED no passo 1 — mostra o RA recebido -->
                    <el-col :xs="24" :sm="5" :md="5" v-if="dados['aluno']['codigo_sed']">
                        <el-form-item label="RA (SED)" key="ra_sed">
                            <el-input readonly :value="dados['aluno']['codigo_sed'] + '-' + (dados['aluno']['sed_ra_digito'] || '') + '/' + (dados['aluno']['sed_ra_uf'] || 'SP')" class="readonly"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Data Nascimento" prop="aluno.data_nascimento" :rules="[$requiredChange]" key="data_nascimento">
                            <el-input readonly v-model="dados['aluno']['data_nascimento']" maxlength="191" class="readonly"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    
                    <el-col :xs="24" :sm="(dados['transporte']) ? 16 : 24" :md="(dados['transporte']) ? 16 : 24">
                        <el-form-item label="Necessidade de Transporte Escolar?" prop="transporte" :rules="[$requiredChange]" key="transporte">
                            <el-select v-model="dados['transporte']" >
                                <el-option :key="true" label="SIM" :value="true"></el-option>
                                <el-option :key="false" label="NÃO" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="dados['transporte']" :xs="24" :sm="8" :md="8">
                        <el-form-item label="Tipo de Transporte" prop="tipo_transporte_id" :rules="[$requiredChange]" key="tipo_transporte_id">
                            <el-select v-model="dados['tipo_transporte_id']" >
                                <el-option
                                    v-for="item in transportes"
                                    :key="item.id"
                                    :label="item.nome"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Observação" key="observacao">
                            <el-input v-model="dados['observacao']" maxlength="191"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </c-panel>
            <c-panel title="Enturmação">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="20" :md="20">

                        <template v-if="$store.state.user.tipo > 3 && $store.state.user.tipo <= 8">
                            <el-form-item label="Instituição" prop="instituicao_id" :rules="[$requiredChange]" key="instituicao_id">
                                <el-select @change="changeInstituicao()" v-model="dados.instituicao_id" filterable>
                                    <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>

                        <template v-if="$store.state.user.tipo <= 3 || $store.state.user.tipo >= 9">
                            <el-form-item label="Instituição">
                                <el-input readonly v-model="$store.state.config.instituicao.nome" maxlength="191" class="readonly"></el-input>
                            </el-form-item>
                        </template>

                    </el-col>
                    <el-col :xs="24" :sm="4" :md="4">
                        <el-form-item label="Período" prop="periodo.nome" :rules="[$requiredChange]" key="periodo">
                            <el-input readonly v-model="dados['periodo']['nome']" maxlength="191" class="readonly"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Curso Nacional" prop="referencia_nacional" :rules="[$requiredChange]" key="referencia_nacional">
                            <el-select v-model="dados['referencia_nacional']"  @change="getTurmas()">
                                <template v-for="(curso, i) in cursosNacionais">
                                    <el-option :key="i" :label="curso.nome" :value="curso.referencia_nacional"></el-option>
                                </template>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Turma" prop="turma" :rules="[$requiredChange]" key="turma">
                            <el-select v-model="dados.turma" >
                                <el-option-group v-for="(curso, i) in turmas" :key="i" :label="i">
                                    <template v-for="item in curso">
                                       <el-option :key="item.id" :label="item.vagas_disponiveis" :value="item.id"></el-option>
                                    </template>
                                </el-option-group>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>



                <div v-if="input_autorizacao">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Código de Autorização" prop="autorizacao_smed" key="autorizacao_smed">
                                <el-input v-model="dados.autorizacao_smed" maxlength="191"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-alert title="Você poderá informar um código de autorização gerado pela SMED para concluir a matrícula." type="warning"></el-alert>
                </div>

                <div class="container-avisos-matricula">
                    <!-- <i class="u-mt-10" style="display: block;" v-if="compativel_eja">* Idade do aluno compatível com turma de Eja</i> -->
                </div>

            </c-panel>
            <c-panel>
                <el-row :gutter="10">
                    <el-col :xs="24">
                        <div style="display: flex; justify-content: space-between;">
                            <el-button type="danger" @click="changeStep(0)">VOLTAR</el-button>

                            <el-button type="primary" native-type="submit">CONCLUIR MATRÍCULA</el-button>
                        </div>
                    </el-col>
                </el-row>
            </c-panel>
        </el-form>

        <!-- Integração SED: matrícula ativa em escola de fora da rede pede a inscrição de transferência -->
        <inscricao-transferencia :visible.sync="showInscricao" :pedido="pedidoInscricao" v-on:inscrito="onInscrito"></inscricao-transferencia>

        <!-- Integração SED: aluno sem matrícula ativa e sem inscrição (ex.: baixa por transferência) pede a inscrição de fora da rede -->
        <inscricao-fora-rede :visible.sync="showInscricaoForaRede" :pedido="pedidoInscricao" v-on:inscrito="onInscrito"></inscricao-fora-rede>

    </div>
</template>
<script>
import inscricaoTransferencia from '@/components/matricula/inscricao-transferencia'
import inscricaoForaRede from '@/components/matricula/inscricao-fora-rede'

export default {
    props: ['aluno'],
    data: () => ({
        showInscricao: false,
        showInscricaoForaRede: false,
        pedidoInscricao: null,
        matriculaAlunoEmTransferencia: false,
        input_autorizacao: false,
        compativel_acelera_um: false,
        compativel_acelera_dois: false,
        compativel_acelera_tres: false,
        compativel_eja: false,
        dados:{
            aluno: { id: '', nome: '', data_nascimento: '' },
            autoriza_uso_imagem: '',
            observacao: '',
            instituicao_id: '',
            periodo: '',
            data_nascimento: '',
            transporte: '',
            tipo_transporte_id: '',
            referencia_nacional: '',
            turma: '',
            autorizacao_smed: ''
        },
        transportes: [],
        cursosNacionais: [],
        turmas: []
    }),
    mounted(){

        this.getTransportes();
    
    },
    methods:{
        getTurmaSelecionadaPreMatricula(){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/pre-matricula/getTurmaSelecionadaPreMatricula/${this.dados.aluno.id}`, this.$store.getters.getHeaderAuth).then(response => {

                let localizado = false;
                for(let i in this.turmas) {
                    for(let j in this.turmas[i]) {

                        if(this.turmas[i][j].id == response.data) {
                            this.turmas[i][j].vagas_disponiveis += ' - AGENDADO';
                            localizado = true;
                        }
                    }
                }

                if(localizado) {
                    this.dados.turma = response.data;
                }

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        changeStep(step){

            this.$emit('changeStep', step);
        },
        changeInstituicao(){

            this.dados.referencia_nacional = '';
            this.dados.turma = '';
            this.getRefNacional();
        },
        getRefNacional(){
        //BUSCA TODAS OS CURSOS DE UMA INSTITUIÇÃO

            if(!this.dados.instituicao_id){
                return false;
            }

            window.eventBus.$emit('loading', true);

            let p = this.$store.state.config.periodo.id;
            let i = this.dados.instituicao_id;

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/curso/getRefNacionalByInstituicao`, {i, p, aluno_id: this.dados.aluno.id}, this.$store.getters.getHeaderAuth).then(response => {

                this.cursosNacionais = JSON.parse(JSON.stringify(response.data));

                if(this.cursosNacionais.length == 1){

                    this.dados['referencia_nacional'] = this.cursosNacionais[0].referencia_nacional;
                    this.getTurmas();
                }

                window.eventBus.$emit('loading', false);

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getTransportes(){
        //BUSCA OS TIPOS DE TRANSPORTES DISPONÍVEIS NA REDE

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/transporte/getAll`, this.$store.getters.getHeaderAuth).then(response => {

                this.transportes = response.data;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getTurmas(){
        //BUSCA AS TURMAS DISPONÍVEIS PARA UMA DETERMINADA CURSO

            window.eventBus.$emit('loading', true);

            let data = {
                instituicao_id: this.dados.instituicao_id,
                periodo_letivo_id: this.dados.periodo.id,
                referencia_nacional: this.dados.referencia_nacional,
                data_nascimento: this.dados.aluno.data_nascimento,
                aluno_id: this.dados.aluno.id,
                id_pre_matricula: (this.$route.query.id_pre_matricula ? this.$route.query.id_pre_matricula : null)
            };

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/turma/getAllByReferenciaNacional`, data, this.$store.getters.getHeaderAuth).then(response => {

                if(!this.$route.query.turma_id) {
                    this.dados.turma = '';
                }

                this.turmas = response.data.turmas;
                this.compativel_acelera_um = response.data.compativel_acelera_um;
                this.compativel_acelera_dois = response.data.compativel_acelera_dois;
                this.compativel_acelera_tres = response.data.compativel_acelera_tres;
                this.compativel_eja = response.data.compativel_eja;
                window.eventBus.$emit('loading', false);

                if(this.$store.state.config.parametros.fase_matricula == 2) {
                    this.getTurmaSelecionadaPreMatricula();
                }

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

        },
        onInscrito(){

            // Inscrição feita na SED: a SED passa a aceitar a matrícula, então ela é concluída na sequência, sem novo clique.
            // Se a matrícula for recusada (ex.: turma sem vaga), a inscrição continua aberta e é só corrigir e concluir de novo.
            this.onSubmitMatricula();
        },
        onSubmitMatricula(){

            this.$refs.dados.validate((valid) =>{ if(valid){

                let dados = {

                    situacao_matricula: 1,
                    aluno_id: this.dados.aluno['id'],
                    turma_id: this.dados['turma'],
                    referencia_nacional: this.dados['referencia_nacional'],
                    tipo_transporte_id: this.dados['tipo_transporte_id'],
                    instituicao_id: this.dados.instituicao_id,
                    periodo_letivo_id: this.dados.periodo['id'],
                    autorizacao_smed: this.dados.autorizacao_smed,
                    autoriza_uso_imagem: this.dados.autoriza_uso_imagem,
                    observacao: this.dados.observacao,
                    id_pre_matricula: (this.$route.query.id_pre_matricula ? this.$route.query.id_pre_matricula : null)
                }

                window.eventBus.$emit('loading', true);

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/matricula/novaMatricula`, dados, this.$store.getters.getHeaderAuth).then(response => {

                    const pedeInscricao = Array.isArray(response.data.throw) ? response.data.throw.find(t => t.codigo === 'SED_PEDE_INSCRICAO_TRANSFERENCIA') : null;

                    const pedeForaRede = Array.isArray(response.data.throw) ? response.data.throw.find(t => t.codigo === 'SED_PEDE_INSCRICAO_FORA_REDE') : null;

                    if(pedeInscricao){

                        // O servidor pede a inscrição de transferência: abre o diálogo (a recusa da matrícula não é um erro a exibir).
                        this.pedidoInscricao = pedeInscricao;
                        this.showInscricao = true;

                    }else if(pedeForaRede){

                        // Aluno sem matrícula ativa e sem inscrição: abre o diálogo da inscrição de aluno de fora da rede.
                        this.pedidoInscricao = pedeForaRede;
                        this.showInscricaoForaRede = true;

                    }else if(typeof response.data.throw !== 'undefined'){

                        if(this.dados.autorizacao_smed){

                            this.$alert('O código de autorização informado não é válido.', 'Atenção', { confirmButtonText: 'OK' });

                        }else{

                            window.eventBus.$emit('throw', response.data.throw);
                            this.input_autorizacao = true;
                        }

                    }else{

                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Matricula realizada com Sucesso!', type: 'success'});
                        window.eventBus.$emit('print', {url: '/api/pdf/renderRequerimentoMatricula', param: response.data.id});

                        this.$emit('onSubmitMatricula');
                    }

                    window.eventBus.$emit('loading', false);

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });


            }else{ window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'}); }});
        },
    },
    watch: {
        aluno: {
            immediate: true,
            handler (value) {

                this.dados.aluno = JSON.parse(JSON.stringify(value));

                if(this.$store.state.config.instituicao && this.$store.state.config.instituicao.id){

                    this.dados.instituicao_id = JSON.parse(JSON.stringify(this.$store.state.config.instituicao.id));

                    this.getRefNacional();
                }

                this.dados.periodo = JSON.parse(JSON.stringify(this.$store.state.config.periodo));

                if(Object.keys(this.$route.query).length !== 0){

                    if(this.$route.query.referencia_nacional) {
                        this.dados.referencia_nacional = parseInt(this.$route.query.referencia_nacional);
                    }
                    if(this.$route.query.turma_id) {
                        this.dados.turma = parseInt(this.$route.query.turma_id);
                    }
                    // A URL do "NOVO ALUNO" (busca na SED) também traz parâmetros, mas sem instituição: só sobrescreve quando ela vier.
                    if(this.$route.query.instituicao_id) this.dados.instituicao_id = parseInt(this.$route.query.instituicao_id);

                    this.getTurmas();                    
                }

            }
        },
    },
    components:{ inscricaoTransferencia, inscricaoForaRede }
}
</script>
